import { Container, Sprite, Text, TextStyle } from "pixi.js";
import { GameFont } from "../../../common/GameFont";
import { CheckoutsTooltipResourcePackage } from "../../../common/resources/CheckoutsTooltipResourcePackage";

export class CheckOutShopTooltip extends Container {
    public constructor(
        checkoutsTooltipResources: CheckoutsTooltipResourcePackage
    ) {
        super();
        const background = new Sprite(checkoutsTooltipResources.assets_views_checkouts_tooltip_tooltip_base_variant3_png);
        background.width = 662;
        background.height = 377;
        background.anchor.set(0.5);
        this.addChild(background);
        const tooltipUnion = new Sprite(checkoutsTooltipResources.assets_views_checkouts_tooltip_tooltip_union_variant1_png);
        tooltipUnion.width = 661.82;
        tooltipUnion.height = 183.73;
        tooltipUnion.anchor.set(0.5);
        tooltipUnion.position.y = -143;
        this.addChild(tooltipUnion);
        tooltipUnion.scale.y *= -1;
        const tooltipText = new Text('THERE’S A NEW SHOP IN TOWN,\nCHECK IT OUT NOW', new TooltipTextStyle());
        tooltipText.anchor.x = 0.5;
        tooltipText.position.set(background.x, -44);
        this.addChild(tooltipText);
    }
}

class TooltipTextStyle extends TextStyle {
    public constructor() {
        super(new TextStyle({
            fill: "#ffffff",
            align: "center",
            fontFamily: GameFont.DEFAULT_FONT,
            fontSize: 64,
            lineHeight: 73
        }));
    }
}